import React from 'react';

interface CancelConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  shiftLocation: string;
  shiftDate: string;
  isLoading: boolean;
  title?: string;
  message?: string;
  confirmLabel?: string;
}

const CancelConfirmationModal: React.FC<CancelConfirmationModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  shiftLocation,
  shiftDate,
  isLoading,
  title = "Cancel Shift Request",
  message = "Are you sure you want to cancel your request for:",
  confirmLabel = "Yes, Cancel Request",
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[1400] p-4">
      <div className="bg-white rounded-2xl p-6 w-full max-w-md">
        <h3 className="text-[20px] leading-7 font-medium text-gray-800 mb-4">
          {title}
        </h3>

        <div className="mb-6">
          <p className="text-[16px] leading-6 text-gray-600 mb-3">
            {message}
          </p>
          <div className="bg-gray-50 rounded-lg p-3">
            <p className="text-[18px] leading-6 font-medium text-gray-800">{shiftLocation}</p>
            <p className="text-[16px] leading-6 text-gray-600 mt-1">{shiftDate}</p>
          </div>
          <p className="text-[14px] leading-5 text-gray-500 mt-3">
            This action cannot be undone.
          </p>
        </div>
        
        <div className="flex space-x-3">
          <button
            type="button"
            onClick={onClose}
            disabled={isLoading}
            className="flex-1 py-2 px-4 border border-gray-300 rounded-lg text-[16px] font-medium text-gray-700 hover:bg-gray-50 transition-colors disabled:opacity-50"
          >
            No, Keep Request
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={isLoading}
            className="flex-1 py-2 px-4 bg-transparent border border-red-600 text-red-600 rounded-lg text-[16px] font-medium hover:bg-red-50 transition-colors disabled:opacity-50"
          >
            {isLoading ? (
              <div className="flex items-center justify-center">
                <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-red-600 mr-2"></div>
                Canceling...
              </div>
            ) : (
              confirmLabel
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CancelConfirmationModal;
